/**
 * Copyright (c) 2018-present, Luojun Jin
 *
 * @emails john.king.ca@gmail.com
 */


import Layout from './Layout';

export default Layout;
